import Table from "../../component/table/table";
import { useParams } from "react-router-dom";


function Parking() {
    const { id } = useParams();


    return (  
    <>
    {/* <Navbar/> */}
    <Table id={id} />
    </>
    );
}

export default Parking;